import { z } from 'zod';

export const ADMIN_ROLES = ['admin', 'cs'] as const;
export const AdminRoleSchema = z.enum(ADMIN_ROLES);
export type AdminRole = z.infer<typeof AdminRoleSchema>;

export const IntercomTeammateRefSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
});
export type IntercomTeammateRef = z.infer<typeof IntercomTeammateRefSchema>;

export const AdminUserSchema = z.object({
  id: z.uuid(),
  email: z.email(),
  role: AdminRoleSchema,
  isActive: z.boolean(),
  createdAt: z.iso.datetime(),
  lastLoginAt: z.iso.datetime().nullable(),
  intercomTeammate: IntercomTeammateRefSchema.nullable(),
});
export type AdminUser = z.infer<typeof AdminUserSchema>;

export const AdminUserListSchema = z.array(AdminUserSchema);
export type AdminUserList = z.infer<typeof AdminUserListSchema>;

export const CreateAdminUserSchema = z.object({
  email: z.email(),
  role: AdminRoleSchema.default('admin'),
});
export type CreateAdminUser = z.infer<typeof CreateAdminUserSchema>;

export const CurrentAdminUserSchema = z.object({
  id: z.uuid(),
  email: z.email(),
  role: AdminRoleSchema,
});
export type CurrentAdminUser = z.infer<typeof CurrentAdminUserSchema>;
